/**
 * Global search modal behavior
 */
class GlobalSearchLinks extends DrupalBehavior {

  onContent(context) {
    // Initialize javascript.
    this.initAutocomplete(context);
  }

  initAutocomplete(context) {
    $('.global-search [name="keywords"]', context).each((index, element) => {
      const url = $(element).attr('data-autocomplete-url');
      const $submit =  $(element).parents('form:first').find('[type="submit"]');
      new autoComplete({
        selector: element,
        minChars: 3,
        delay: 50,
        source: function(term, response){
          $.getJSON(url, {
            keywords: term.replace("'", ""),
          },
          function(data) {
            response(data);
          });
        },
        onSelect: function(e, term, item){
          // Redirect to search page.
          $submit.click();
        },
        // Mostly we use default callback with minimal modifications.
        // @see https://goodies.pixabay.com/javascript/auto-complete/demo.html
        renderItem: function (item, search){
          search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
          return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
        }
      })
    });
  }
}

DrupalBehavior.register('psh_theme.components', 'global-search-links', GlobalSearchLinks);
